import { Divider, Paper } from '@mui/material';
import { ClaimEventResponseItem } from 'API';
import { GeneralData } from './GeneralData';
import { StageAndMoreInfo } from './StageAndMoreInfo';
import { useIsDesktop } from 'Hooks';
import {
  getLastStepIndex,
  getRecognitionStatusSteps,
} from 'Utils/recognitionStatusHelperFunctions';

interface ISectionItem {
  claimEvent: ClaimEventResponseItem;
}
export const SectionItem = ({ claimEvent }: ISectionItem) => {
  const isDesktop = useIsDesktop();

  const latestEvent = claimEvent.claimEvents.at(-1);

  return (
    <Paper
      sx={{
        borderRadius: '16px',
        border: '1px solid #E7EDFF',
        bgcolor: '#FFF',
        padding: isDesktop ? '24px 24px 32px 24px' : '24px 24px 54px 24px',
        maxWidth: '640px',
        boxShadow: 'none',
        position: isDesktop ? undefined : 'relative',
      }}
    >
      <GeneralData
        matter={claimEvent.pgimaDescription}
        treatmentStage={{
          stepId: latestEvent?.treatStepsGroupId,
          decisionType: latestEvent?.decisionType,
          isCurrentStep: true,
        }}
        updateDate={latestEvent?.statusDate}
      />
      {isDesktop && (
        <Divider sx={{ margin: '24px 0', borderColor: 'primary.shade_100' }} />
      )}
      <StageAndMoreInfo
        stepsAmount={getRecognitionStatusSteps(claimEvent).length}
        currentStep={getLastStepIndex(claimEvent)}
        claimEventNumber={latestEvent?.pgimaNumber}
      />
    </Paper>
  );
};
